import { EyeOff } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useDemoMode } from "@/hooks/useDemoMode";

/**
 * Non-dismissable banner shown at the top of the app whenever demo mode is active.
 * The TRUE owner (their session email == the configured owner email) sees a
 * slightly different message so they know they're viewing REAL data while the
 * public sees anonymized data.
 */
export default function DemoBanner() {
  const { user } = useAuth();
  const { active } = useDemoMode();
  if (!active) return null;

  const isTrueOwner = !!user?.is_true_owner;

  return (
    <div
      className="w-full bg-amber-50 border-b border-amber-200 text-amber-900"
      data-testid="demo-mode-banner"
    >
      <div className="max-w-[1600px] mx-auto px-4 py-2 sm:py-2.5 flex items-center gap-2.5 text-sm">
        <EyeOff className="h-4 w-4 flex-shrink-0" />
        {isTrueOwner ? (
          <p className="leading-tight">
            <span className="font-semibold">Demo-modus staat AAN.</span>{" "}
            Andere bezoekers zien dummy data en verborgen bedragen.
            <span className="hidden sm:inline"> Jij ziet nog steeds de echte cijfers.</span>
          </p>
        ) : (
          <p className="leading-tight">
            <span className="font-semibold">🎭 Demo-modus actief</span>
            <span className="hidden sm:inline"> — gegevens op deze pagina zijn fictief en dienen enkel ter illustratie.</span>
          </p>
        )}
      </div>
    </div>
  );
}
